import { Component, EventEmitter, OnInit, OnChanges, ViewChild, ElementRef, Input, Output } from '@angular/core';

@Component({
    selector: 'number-spinner',
    templateUrl: './number-spinner.component.html',
    styleUrls: ['./number-spinner.component.scss']
})

export class NumberSpinnerComponent {

    @Input() disabled: boolean;
    @Input() required: boolean;
    @Input() roundTo: number;
    @Input() step: number;
    @Input() max: number;
    @Input() min: number;
    @Input() withDot: boolean;
    @Input() inputName: any;
    @Output() onChange = new EventEmitter();
    @Output() numberChange = new EventEmitter();

    @Input() number: number;
    private el: HTMLElement;

    private BackSpaceEventCode = 8;
    private DotEnteredEventCode = 46;
    private SpaceEventCode = 32;
    private MinusSignEnteredEventCode = 45;
    private NumberEnteredLowerLimitEventCode = 48;
    private NumberEnteredUpperLimitEventCode = 57;

    private MAX_NUMBER_LENGTH_LIMIT = 5;

    private ZERO_SYMBOL = '0';
    private MINUS_SYMBOL = '-';
    private DOT_SYMBOL = '.';

    constructor(el: ElementRef) {
        this.el = el.nativeElement;
    }

    public keydownEvent(event) {

        let element = $(this.el.children[0].children[0]);

        if (event.which !== this.BackSpaceEventCode) {

            let number = +(this.number.toString() + event.key);

            if ((this.isNumber(number) || this.isDecimal(number))
                && event.which !== this.SpaceEventCode
                && !this.tooLargeNumberDenied(event, element)
                && !(event.which === this.DotEnteredEventCode && !this.withDot)) {
                this.updateNumber();
            } else {
                event.preventDefault();
            }
        }
        else {
            this.updateNumber();
        }
    }

    private updateNumber() {
        setTimeout(() => {
            this.numberChange.emit(this.number);

            if (this.onChange) {
                this.onChange.emit();
            }
        }, 0);
    }

    private isNumber(number: number) {
        return !this.withDot && !Number.isNaN(number) && Number.isInteger(number);
    }

    private isDecimal(number: number) {
        return this.withDot && !Number.isNaN(number) && !Number.isInteger(number);
    }

    public isValid() {
        if (this.required) {
            return !isNaN(this.number) && this.number !== null && this.number !== undefined;
        }
        return true;
    }

    public steupUp() {

        var value = parseFloat((this.number || 0).toString());
        var nextValue = Math.floor(value / this.step) * this.step + this.step;

        if (value === nextValue) {
            nextValue += this.step;
        }

        if (isNaN(+this.max) || this.max >= nextValue) {
            this.number = nextValue;

            setTimeout(() => {
                this.numberChange.emit(this.number);
                if (this.onChange) {
                    this.onChange.emit();
                }
            }, 0);
        }
    }

    public stepDown() {

        var value = parseFloat((this.number || 0).toString());
        var nextValue = Math.floor(value / this.step) * this.step;

        if (value === nextValue) {
            nextValue -= this.step;
        }

        if (isNaN(+this.min) || this.min <= nextValue) {
            this.number = nextValue;
         
            setTimeout(() => {
                this.numberChange.emit(this.number);
                if (this.onChange) {
                    this.onChange.emit();
                }
            }, 0);
        }
    }

    private tooLargeNumberDenied(event, element) {

        if (event.which === this.DotEnteredEventCode || event.which === this.MinusSignEnteredEventCode) {
            return false;
        }

        var inputValue = this.gettextWithoutSelection(element);
        var indexOfDot = inputValue.indexOf(this.DOT_SYMBOL);

        if (indexOfDot !== -1) {

            var cursorPosition = this.getCursorPosition(element);

            if (cursorPosition <= indexOfDot) {

                var numberText = inputValue.split(this.DOT_SYMBOL)[0];
                var numberTextLength = numberText.indexOf(this.MINUS_SYMBOL) === -1 ? numberText.length + 1 : numberText.length;
                return numberTextLength > this.MAX_NUMBER_LENGTH_LIMIT;
            } else {
                return false;
            }
        }

        var textLength = inputValue.indexOf(this.MINUS_SYMBOL) === -1 ? inputValue.length + 1 : inputValue.length;
        return textLength > this.MAX_NUMBER_LENGTH_LIMIT;
    }

    private getCursorPosition(element) {
        var el = $(element).get(0);
        var pos = 0;
        if ('selectionStart' in el) {
            pos = el.selectionStart;
        }
        return pos;
    }

    private gettextWithoutSelection(element) {

        var el = $(element).get(0);

        if (window.getSelection().toString()) {
            var originalValue = element.val();
            var beforeSelection = originalValue.substring(0, el.selectionStart);
            var afterSelection = originalValue.substring(el.selectionEnd, originalValue.length);
            return beforeSelection + afterSelection;
        }

        return element.val();
    }
}